'use client';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx/lite';
import { useState } from 'react';

export const FaqCard: React.FC<{
  questionFormatted?: React.ReactNode;
  answerFormatted?: React.ReactNode;
  question: string;
  answer: React.ReactNode;
  showDivider?: boolean;
  compact?: boolean;
  className?: string;
}> = ({ questionFormatted, answerFormatted, question, answer, showDivider = false, compact = false, className }) => {
  const [isShowing, handleShow] = useState(false);
  return (
    <div
      className={clsx(
        'flex w-full flex-col bg-neutral-surface',
        showDivider ? 'border-b border-neutral-600' : 'rounded-lg',
        compact ? 'py-5' : 'p-5',
        className,
      )}
    >
      <div className="faq flex flex-col gap-4">
        <button
          aria-label={isShowing ? `Nascondi ${question}` : `Mostra ${question}`}
          onClick={() => handleShow(!isShowing)}
          aria-expanded={isShowing}
        >
          <div className="text-neutral-dark inline-flex w-full items-center justify-between text-left text-lg font-bold">
            {questionFormatted ?? question}
            <span className="ml-4 lg:ml-8">
              {isShowing ? <ChevronUpIcon className="h-6 w-6 text-secondary" /> : <ChevronDownIcon className="h-6 w-6 text-secondary" />}
            </span>
          </div>
        </button>
        <div
          className={clsx(
            'text-base font-medium text-neutral-lighter [&>*]:my-6 [&>:first-child]:mt-0 [&>:last-child]:mb-0 [&>ol]:list-decimal [&>ul]:list-disc [&_a:hover]:text-primary-hover [&_a]:text-neutral-darker [&_a]:underline [&_a]:transition-colors [&_ol]:pl-8 [&_ul]:pl-8',
            isShowing ? 'visible' : 'hidden',
          )}
        >
          {answerFormatted ?? answer}
        </div>
      </div>
    </div>
  );
};
